import KOGInputDragDropUploader from "../inputFile/inputDragDrop";
import { downloadFileMemory } from "@/main/services/utilsFile";
import { QuoteImageResponse } from "@/main/models/response";

interface IFileUploaderProps {
	// required props
	quoteImages: QuoteImageResponse[];
	// Optional props
	isFullScreenDragDrop?: boolean;
	onCustomInsert?: (newFiles: File[]) => void;
}

function QuoteImageUploader({
	quoteImages,
	isFullScreenDragDrop = false,
	onCustomInsert = () => {},
}: IFileUploaderProps) {
	async function handleFileChange(selectedFiles: File[]) {
		if (!selectedFiles || selectedFiles.length == 0) return;
		const newFiles = selectedFiles.filter((file) => !quoteImages.some((image) => image.fileName === file.name));
		const newFilesMemory = await Promise.all(newFiles.map(async (file) => await downloadFileMemory(file)));
		await onCustomInsert(newFilesMemory);
	}

	return (
		<KOGInputDragDropUploader
			files={quoteImages.map((image) => {
				return { name: image.fileName };
			})}
			isFullScreenDragDrop={isFullScreenDragDrop}
			onFilesChange={handleFileChange}
		/>
	);
}

export default QuoteImageUploader;
